<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16">
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Pickup Location:
      </h3>

      <!-- Store Location Details -->
      <cf-receipt-from-location-details :store="receipt.store" />
    </div>

    <!-- Guest Arrived Cta -->
    <cf-guest-arrived-cta
      v-if="isGuestArrivedButtonEnabled"
      :auto-open="$route.query.hasOwnProperty('here')"
      :order="receipt"
      :receipt-token="receiptToken"
    />

    <!-- Receipt Pickup Instructions -->
    <template v-if="receipt.pickupInstructions">
      <cf-title-separator :omit-title="true" />

      <div class="cf-flex cf-flex--column cf-flex--gap-12">
        <h3 class="cf-title cf-title--3">
          {{ computedPickUpInstructionsHeader }}:
        </h3>

        <cf-formatted-content :content="receipt.pickupInstructions" />
      </div>
    </template>

    <cf-title-separator :omit-title="true" />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfReceiptFromLocationDetails from '@/view/components/globals/cf-receipt-from-location-details/index.vue';
  import CfGuestArrivedCta from '@/view/components/globals/cf-guest-arrived-cta/index.vue';
  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';


  export default {
    name: 'TakeoutReceiptFulfillmentDetails',

    components: {
      CfReceiptFromLocationDetails,
      CfTitleSeparator,
      CfGuestArrivedCta,
      CfFormattedContent
    },

    props: {
      receipt: {
        type: Object,
        required: true
      },

      isGuestReceipt: {
        type: Boolean,
        default: false
      },

      hideGuestArrivedCta: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('content', ['content', 'dynamicContent']),

      computedPickUpInstructionsHeader() {
        const driveThroughSubstring = this.content.OrderSummary?.metadata.driveThroughSelection || 'Drive-Through';

        const curbsideSubString = this.content.OrderSummary?.metadata.curbsideSelection || 'Curbside';

        switch (this.receipt.pickupLocation) {
          case 'curbside':
            return `${curbsideSubString} Instructions`;
          case 'drive-through':
            return `${driveThroughSubstring} Instructions`;
          default:
            return 'Pickup Instructions';
        }
      },

      isGuestArrivedButtonEnabled() {
        const { store, pickupLocation } = this.receipt;

        const hasOnSiteNotificationsEnabled = (pickupLocation === 'take-out' && store.onSiteNotificationEnabled)
          || (pickupLocation === 'curbside' && store.onSiteCurbsideNotificationEnabled)
          || (pickupLocation === 'drive-through' && store.onSiteDriveThroughNotificationEnabled);

        return !this.isGuestReceipt && hasOnSiteNotificationsEnabled && !this.hideGuestArrivedCta;
      },

      receiptToken() {
        return this.$route?.params?.receiptToken;
      }
    }
  };
</script>
